import * as types from "../../constants/actionTypes";
import moment from 'moment';

const initState = {
    isLoading: false,
    listObat: [],
    masterData: [],
    listObatMasuk: [],
    listObatKeluar: [],
    formObat: {
        f_id_obat: "",
        f_nama_obat: "",
        f_kode_obat: "",
        f_stok_obat: 0,
        f_harga_obat: "",
        f_nama_produsen: null,
        f_satuan_hitung: null,
        f_status_produsen: true,
    },
    formObatMasuk: {
        f_tgl_masuk: "",
        f_tgl_kadaluarsa: "",
        f_catatan: null,
        f_jmlh_obat: "",
        f_id_obat: "",
        f_id_klinik: "",
        f_status_catatan: false,
    }
    
};

export default function (state = initState, action) {
    switch (action.type) {
        case types.MODULE_OBAT_SET_LOADER: {
            return{
                ...state,
                isLoading: action.value
            }
        }
        case types.MODULE_OBAT_DATA_GET_ALL_SUCCESS: {
            return{
                ...state,
                listObat: action.value
            }
        }
        case types.MODULE_OBAT_MASUK_DATA_GET_ALL_SUCCESS: {
            return{
                ...state,
                listObatMasuk: action.value
            }
        }
        case types.MODULE_OBAT_DATA_GET_DETAIL_SUCCESS: {
            return{
                ...state,
                formObat: action.value
            }
        }
        case types.MODULE_OBAT_KELUAR_DATA_GET_ALL_SUCCESS: {
            return{
                ...state,
                listObatKeluar: action.value
            }
        }
        case types.MODULE_OBAT_MASTER_DATA_SUCCESS: {
            return{
                ...state,
                masterData: {
                    ...state.masterData,
                    [action.property] : action.value
                }
            }
        }
        case types.MODULE_OBAT_INIT_FORM_OBAT: {
            return{
                ...state,
                formObat: {
                    ...initState.formObat
                }
            }
        }
        case types.MODULE_OBAT_MASUK_INIT_FORM_OBAT: {
            return{
                ...state,
                formObatMasuk: {
                    ...initState.formObatMasuk
                }
            }
        }
        case types.MODULE_OBAT_HANDLE_STATE_FORM: {
            return {
                ...state,
                formObat: {
                    ...state.formObat,
                    [action.property]: action.value,
                }
            }
        }
        case types.MODULE_OBAT_MASUK_HANDLE_STATE_FORM: {
            return {
                ...state,
                formObatMasuk: {
                    ...state.formObatMasuk,
                    [action.property]: action.value,
                }
            }
        }
        default:
            return {
                ...state
            }
    }
}  